"use client";

import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Home, Star, Users, Trophy, Sparkles, User, type LucideIcon } from "lucide-react";
import Image from "next/image";
import { ConnectWalletButton } from "./connect-wallet-button";

interface DrawerProps {
  isOpen?: boolean;
  onClose?: () => void;
}

interface MenuItem {
  icon: LucideIcon;
  label: string;
  path: string;
  badge?: string;
}

export const YiedlDrawer: React.FC<DrawerProps> = ({
  isOpen = true,
  onClose,
}) => {
  const pathname = usePathname();

  const menuItems: MenuItem[] = [
    { icon: Home, label: "Home", path: "/" },
    { icon: Star, label: "Quests", path: "/quests" },
    { icon: Sparkles, label: "NFT Mint", path: "/mint" },
    { icon: Users, label: "Referrals", path: "/referral" },
    { icon: Trophy, label: "Leaderboard", path: "/leaderboard" },
    // { icon: User, label: "Profile", path: "/profile" },
  ];

  const isActive = (path: string) => pathname === path;

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && onClose && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={onClose}
        />
      )}

      <aside
        className={`
        fixed left-0 top-0 h-screen w-64 bg-yiedl-dark z-50
        transform transition-transform duration-300 ease-out
        ${isOpen ? "translate-x-0" : "-translate-x-full"}
        md:translate-x-0
        flex flex-col
      `}
      >
        <div className="p-6">
          <Link href="/" className="flex items-center gap-3">
            <Image
              src="https://pulsarmoney.b-cdn.net/quests/campaigns/yield/yield-logo.png"
              alt="Yiedl"
              width={120}
              height={40}
              className="w-auto h-10 object-contain"
            />
          </Link>
        </div>

        <nav className="flex-1 px-4">
          <ul className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const active = isActive(item.path);

              return (
                <li key={item.path}>
                  <Link
                    href={item.path}
                    className={`
                      flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ease-out
                      ${
                        active
                          ? "text-white"
                          : "text-neutral-400 hover:text-white"
                      }
                    `}
                    onClick={onClose}
                  >
                    <Icon className="w-5 h-5" strokeWidth={2} />
                    <span className="flex-1 font-medium">{item.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        <div className="p-4">
          <ConnectWalletButton className="w-full" />
        </div>
      </aside>
    </>
  );
};
